import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class DailyProductionService extends GenericService {
  constructor() {
    super('/daily_productions', axiosInstance);
  }
}

export default new DailyProductionService(); 